<div class="users-container">
  <div class="query-strip-container mat-elevation-z2">
    <table height="100%">
            <TR>
                <TD class="table-title-cell">
                    <i class="fa fa-cog table-icon-header"
                       style="width: 2em"></i>{{ formTitle }}
                </TD>

                <TD align="left" style="min-width: 400px;text-align:center;">
                    <input text id="txtFilter" #txtFilter
                           matTooltip="Type to match data in all columns except date fields"
                           class="qs_filter-field" [disabled]="this.isEditing"
                           (keyup)="applyFilter($event.target.value)" placeholder="<Filter>">
                    <button mat-button matSuffix mat-icon-button
                            matTooltip="Clear the filter" aria-label="Clear"
                            (click)="txtFilter.value=''; clearFilter();">
                        <mat-icon>close</mat-icon>
                    </button>
                </TD>
                <TD class="qs-label-cell" style="width: 60px; text-align: center;">Status:</TD>
                <TD style="width: 150px">
                    <mat-select
                            disableOptionCentering
                            [(value)]="selectedStatusFilter" floatLabel="never"
                            class="dw-mat-select"
                            style="font-size: 10pt;width: 120px;"
                            panelClass="local-drop-down-panel"
                            (selectionChange)="txtFilter.value=''; onChangeStatusFilterValue()">
                        <mat-option value='All'>All</mat-option>
                        <mat-option value='Active'>Active</mat-option>
                        <mat-option value='InActive'>InActive</mat-option>
                    </mat-select>
                </TD>
                <TD class="table-pagination-cell" align="right">{{ pagination }} Record(s) ...</TD>
            </TR>
        </table>
  </div>

 <div [ngClass]="contentClassName" class="table-container mat-elevation-z2"
	(keydown)="tableKeyDown($event)" tabindex="-1">
	<table mat-table [dataSource]="dataSource" 
		(matSortChange)="onSortChange($event)" matSort>


		<ng-container matColumnDef="id">
		<th mat-header-cell class="mat-table-header-style" *matHeaderCellDef mat-sort-header >Id</th>
		<td mat-cell class="mat-table-row-style-override" style="min-width: 25px; width:6% !important;"
			*matCellDef="let element;let tableRowIdx = index;">
			{{element.id}}</td>
		</ng-container>

		<!--Security element Column -->
		<ng-container matColumnDef="name" >
		<th mat-header-cell class="mat-table-header-style" *matHeaderCellDef mat-sort-header>Security Element</th>
		<td mat-cell class="mat-table-row-style-override" style="width:12% !important;padding-right: 8px;"
			*matCellDef="let element">{{element.name}}</td>
		</ng-container>
		
		<ng-container matColumnDef="description">
		  <th mat-header-cell class="mat-table-header-style" *matHeaderCellDef mat-sort-header>
		    Description
		  </th>
		  <td mat-cell class="mat-table-row-style-override description-cell"
		      style="width:35% !important;padding-right: 8px;"
		      *matCellDef="let element"
		      matTooltip="{{element.description}}"
		      matTooltipClass="custom-tooltip"
		      matTooltipPosition="above">
		    {{ element.description | slice:0:100 }}<span *ngIf="element.description?.length > 100"> &nbsp;...</span>
		  </td>
		</ng-container>


		<!-- Primary Path Column -->

		<ng-container matColumnDef="primaryPath">
			<th mat-header-cell  class="mat-table-header-style" *matHeaderCellDef mat-sort-header>Primary Path</th>
			<td mat-cell class="mat-table-row-style-override" style="width: 20%;padding-right: 8px;"
				*matCellDef="let element">{{element.primaryPath}}</td>
		</ng-container>

        <!-- Element Type Column -->

        <ng-container matColumnDef="elementType">
            <th mat-header-cell  class="mat-table-header-style" *matHeaderCellDef mat-sort-header>Type</th>
            <td mat-cell class="mat-table-row-style-override" style="width: 8%;"
                *matCellDef="let element">{{element.elementType}}</td>
        </ng-container>
        
        <ng-container matColumnDef="options" >
		<th mat-header-cell class="mat-table-header-style" *matHeaderCellDef mat-sort-header>Option Usage</th>
		<td mat-cell class="mat-table-row-style-override" style="width:10% !important;padding-right: 8px;"
			*matCellDef="let element">{{element.options}}</td>
		</ng-container>

		 <!-- Active Status -->
                    <ng-container matColumnDef="activeStatus">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header
                            style="background-color: white; z-index:99999">Status
                        </th>
                        <td mat-cell class="mat-table-row-style-override" *matCellDef="let element" >

                            <dw-dropdown *ngIf="selectedRecord?.id == element.id"
                                         [disabled]="isEditing || !visibleModify"
                                         [useStatusOptions]="'status'"
                                         [selectedItem]="element.activeStatus"
                                         [controlWidth]="'120px'"
                                         (itemSelected)="element.activeStatus = $event; onStatusChange()">
                            </dw-dropdown>

                            <span *ngIf="selectedRecord?.id !== element.id"
                                  class="mat-table-row-style-override"
                                  style="padding-left: 3px;">{{element.activeStatus}}</span>
                        </td>
           </ng-container>
		
		<tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
		<tr mat-row
			*matRowDef="let row; columns: displayedColumns;
				let tableRowIdx = index;"
			[ngClass]="{'row-selected': tableRowIdx == Idx}"
			(click)="onRowClicked(row)">

		</tr>
	</table>
</div>

  <div class="mat-elevation-z2 control-strip">
    <button mat-button class="command-button"
            *ngIf="visibleModify" [disabled]="Idx < 0 || isEditing" style="margin-top: 5px;"
            matTooltip="Edit selected record" (click)="addModifyRecord(false)">
      <mat-icon>edit</mat-icon> Edit
    </button>
  </div>

  <div class="usermgmt-container">
    <div class="dwform" style="padding-right: 15px;">
      <div class="dwform-cell" style="min-width: 500px;">
		<div class="dwform-row-gap"></div>
		
        <div class="dwform-row">
          <label class="label-field">ID:</label><span class="form-required"></span>
          <input class="input-field-shortest detail-input-class" [(ngModel)]="id" type="text" disabled>
        </div>
		<div class="dwform-row-gap"></div>
		
        <div class="dwform-row">
          <label class="label-field">Security Element:</label><span class="form-required">*</span>
          <input class="input-field-longest detail-input-class" [(ngModel)]="name" placeholder="<Security Target>"
                 type="text" disabled>
        </div>
		<div class="dwform-row-gap"></div>
		
        <div class="dwform-row">
          <label class="label-field">Code:</label><span class="form-required">*</span>
          <input class="input-field-longest detail-input-class" [(ngModel)]="code" placeholder="<Code>"
                 type="text" disabled>
        </div>
		<div class="dwform-row-gap"></div>
		
        <div class="dwform-row">
          <label class="label-field">Primary Path:</label><span class="form-required">*</span>
          <input class="input-field-longest detail-input-class" [(ngModel)]="primaryPath" placeholder="<Primary Path>"
                 type="text" disabled>
        </div>
		<div class="dwform-row-gap"></div>
		
        <div class="dwform-row">
          <label class="label-field">Used In Multiple Areas:</label><span class="form-required"></span>
          <mat-checkbox [(ngModel)]="usedInMultipleAreas" disabled></mat-checkbox>
        </div>
		<div class="dwform-row-gap"></div>
		
        <div class="dwform-row">
          <label class="label-field" style="vertical-align: top;padding-top:3px;">Description:</label><span class="form-required">*</span>
          <textarea class="input-field detail-input-class" [(ngModel)]="description" [disabled]="!isEditing"
          		style="font-family: Roboto; width:380px; height: 100px; resize: none;">
           </textarea>
        </div>
	</div>
	<div class="dwform-cell" style="min-width: 400px;">
		<div class="dwform-row-gap"></div>
		
        <div class="dwform-row">
          <label class="label-field">Element Type:</label><span class="form-required">*</span>
          <dw-dropdown
                 disabled
                [controlWidth]="'180px'"
                [dataSource]="elementTypeList"
                (itemSelected)="elementType = $event"
                [selectedItem]="elementType">
          </dw-dropdown>
        </div>
		<div class="dwform-row-gap"></div>
		
        <div class="dwform-row">
             <label class="label-field">Status:</label> <span class="form-required">*</span>
             <dw-dropdown
                     id="activeStatusId"
                     [disabled]="!isEditing"
                     [selectedItem]="activeStatus"
                     (itemSelected)="activeStatus = $event"
                     [controlWidth]="'120px'" [useStatusOptions]="'status'">
             </dw-dropdown>

        </div>
		<div class="dwform-row-gap"></div>
		
      <div class="dwform-row" style="display: flex; align-items: flex-start;padding-top:10px;">
		  <label class="label-field">Usable Options:</label>
		  <span class="form-required" style="margin-right: 10px;">*</span>
		  <mat-selection-list [(ngModel)]="usableOptions" disabled
		    [ngModelOptions]="{ standalone: true }" class="right-type-list">
		    <mat-list-option *ngFor="let option of usableOptionsList" [value]="option">
		      {{ option }}
		    </mat-list-option>
		  </mat-selection-list>
		</div>

        <div class="dwform-row-gap"></div>
        <div class="error-line" [hidden]="!strErr.length">{{ strErr }}</div>

        <div class="save-close-strip">
          <button mat-button class="command-button" *ngIf="isEditing"
                  (click)="submitRecord()">
            <mat-icon>check_circle_outline</mat-icon> Submit
          </button>
          <button mat-button class="command-button" *ngIf="isEditing"
                  (click)="cancelSubmitRecord()">
            <mat-icon>highlight_off</mat-icon> Cancel
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
